import { CalendarMonth } from '@mui/icons-material';
import {
  Box,
  BoxProps,
  Button,
  Divider,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcons } from 'modules/components/layer00';
import React, { ReactNode } from 'react';



export interface ILightSummaryMetricCardLayoutProps {
  dataSource: string;
  dataLink: string;
  children?: ReactNode | ReactNode [];
}

export const FC = (props: ILightSummaryMetricCardLayoutProps & BoxProps) => {
  const theme = useTheme();



  const [
    anchorEl,
    setAnchorEl
  ] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);


  return (

    <Box
      bgcolor='#fff'
      borderRadius='1rem'
      padding='1rem'
    >
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >

        <Box
          display='flex'
          flexDirection='row'
          alignItems='center'
        >

          <Typography
            variant='dataSummaryCardTitle'
            color={theme.palette.primary.darker200}
          >
            {props.dataSource}
          </Typography>
          <Divider
            sx={{
              // paddingX: '1rem',
              maringTop: '10px',
              height: '.5rem',
              borderWidth: '.0625rem',
              marginLeft: '.75rem',
              marginRight: '.25rem'

            }}
            orientation='vertical'
            variant='inset'
            color={theme.palette.gray.light10}
          />

          <Button
            component='a'
            href={props.dataLink}
            target='_blank'
            variant='text'
            color='primary'
            endIcon={<CustomIcons.SmallCustomIcon.FC icon='STATLINK' stroke={theme.palette.primary.main} />}
            // onClick={()=>{navigate(props.dataLink, {target: "_"});}}
          >
            Source
          </Button>
        </Box>
        <Box>

          <Button
            sx={{
              boxShadow: 'none',
              height: '2rem'
            }}
            variant='outlined'
            color='secondary'
            startIcon={<CalendarMonth />}

          >
            Latest
          </Button>
          <Menu
            variant='selectedMenu'
            open={false}
            defaultValue='1M'
          >
            <MenuItem value='1M'>
              <ListItemText>1M</ListItemText>
            </MenuItem>
          </Menu>
        </Box>
      </Box>

      <Box
        maxWidth='45vw'
        display='flex'
        columnGap='1.5rem'
        justifyContent='flex-start'
        sx={{
          overflowX: 'auto'
        }}
      >
        {props.children}
      </Box>

    </Box>

  );
};
